const initialState = {
  doctorList: [],
  doctorSearch: [],
  selectedDoctor: {},
  selectedRadius: '',
  selectedSpecialty: '',
  selectedZip: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_SHOPPER_DOCTORS':
      return { ...state, doctorList: action.doctorList };
    case 'SET_SELECTED_DOCTOR':
      return { ...state, selectedDoctor: action.doctor };
    case 'CLEAR_SELECTED_DOCTOR':
      return { ...state, selectedDoctor: {} };
    case 'SET_DOCTORS_ZIPCODE':
      return { ...state, selectedZip: action.payload };
    case 'SET_DOCTORS_RADIUS':
      return { ...state, selectedRadius: action.payload };
    case 'SET_DOCTORS_SPECIALTY':
      return { ...state, selectedSpecialty: action.payload };
    case 'SET_DOCTORS_SEARCH':
      return { ...state, doctorSearch: action.payload };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
